import { ADVERSE_EVENT_LABELS } from '../../domain/legalAssumptions';
import type { MilestoneCalculation, Scenario } from '../../domain/types';

interface SourceDrawerProps {
  calculation: MilestoneCalculation;
  scenario: Scenario;
  assumptions: string[];
}

export function SourceDrawer({ calculation, scenario, assumptions }: SourceDrawerProps) {
  const milestone = calculation.milestone;

  return (
    <aside className="source-drawer" aria-label="条款来源抽屉">
      <div className="panel-heading">
        <span className="eyebrow">条款来源</span>
        <h2>{milestone.title}</h2>
      </div>

      <section>
        <h3>协议条款</h3>
        <p className="clause-pill">{milestone.sourceClause}</p>
        <p>{milestone.sourceSummary}</p>
      </section>

      <section>
        <h3>验收材料示例</h3>
        <ul>
          {milestone.evidenceExamples.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section>
        <h3>法律提示</h3>
        <p>{milestone.legalNote}</p>
      </section>

      <section>
        <h3>当前计算路径</h3>
        <ol className="trace-list">
          {calculation.trace.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </section>

      <section>
        <h3>场景上下文</h3>
        <dl className="drawer-facts">
          <div>
            <dt>截至日期</dt>
            <dd>{scenario.asOfDate}</dd>
          </div>
          <div>
            <dt>不利事件</dt>
            <dd>{ADVERSE_EVENT_LABELS[scenario.adverseEventReason]}</dd>
          </div>
          <div>
            <dt>服务状态</dt>
            <dd>{scenario.serviceActive ? '持续提供服务' : '已停止服务'}</dd>
          </div>
        </dl>
      </section>

      <section>
        <h3>模型假设</h3>
        <ul>
          {assumptions.slice(0, 4).map((assumption) => (
            <li key={assumption}>{assumption}</li>
          ))}
        </ul>
      </section>
    </aside>
  );
}
